<ng-container *ngIf="!canEdit">
  <ng-container [ngTemplateOutlet]="tag" [ngTemplateOutletContext]="{tag: issue.tag}"></ng-container>
</ng-container>

<ng-container *ngIf="canEdit">
  <div class="tag-label" (click)="showEdit()" *ngIf="!focusInput">
    <ng-container [ngTemplateOutlet]="tag" [ngTemplateOutletContext]="{tag: issue.tag}"></ng-container>
  </div>

  <div class="input" *ngIf="focusInput">
    <ng-select style="height: auto"
               #searchElement
               bindLabel="header"
               bindValue="id"
               [items]="items"
               (change)="changeSelected($event)"
               (blur)="focusChange(false)"
               [(ngModel)]="issue.tag"
               placeholder="">

      <ng-template ng-label-tmp let-item="item">
                  <span style="display: flex">
                    <ng-container [ngTemplateOutlet]="tag" [ngTemplateOutletContext]="{tag: item}"></ng-container>
                  </span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span style="display: flex">
                    <ng-container [ngTemplateOutlet]="tag" [ngTemplateOutletContext]="{tag: item}"></ng-container>
                  </span>
      </ng-template>
    </ng-select>
  </div>
</ng-container>

<ng-template #tag let-tag="tag">
  <ng-container *ngIf="canEdit && !tag?.id">
    нет
  </ng-container>
  <div class="tags" *ngIf="tag?.id">
    <div title="Приоритет: {{ tag.header }}" class="tag-link tag-value" style="background-color: {{ tag.color }}">{{ showHeader(tag) }}</div>
  </div>
</ng-template>
